export const CROP_NAMES = Object.freeze({
  cherry_radish: '樱桃萝卜',
  green_sprout: '小青菜',
  strawberry: '草莓',
  sweet_corn: '甜玉米',
  pumpkin: '南瓜',
  sunflower: '向日葵',
  watermelon: '西瓜',
  cherry_tomato: '樱桃番茄',
});

export const cropName = (cropKey) => {
  const key = String(cropKey || '').trim();
  if (!key) return '-';
  return CROP_NAMES[key] || key;
};
